import React, { useState } from 'react'
import './input-webinar.scss'
import * as Icons from '@material-ui/icons'

const InputWebinar = props => {
    const { placeholder, min, error, disabled, icon = null, onBlur, label, onChange, type = 'text', value, options = null, isWomenWebinar = false, register, ...params } = props
    const errorClass = error ? 'input-error' : ''
    const disabledClass = disabled ? 'input-disabled' : ''
    const iconClass = icon || type === 'password' ? 'input-icon' : ''
    const labelClass = label ? 'f-label-input-webinar' : ''

    // const [isFocus, setisFocus] = useState(false)
    const [typeChange, settypeChange] = useState('password')

    return (
        <div className={"f-input-webinar-group " + ' ' + labelClass}>
            {label && <label className={isWomenWebinar ? "f-label-input-webinar f-label-input-webinar--women": "f-label-input-webinar"}>{label}</label>}
            {type !== 'select' ?
                <input
                    className={(isWomenWebinar ? "f-input-webinar-item f-input-webinar-item--women " :"f-input-webinar-item ") + errorClass + ' ' + disabledClass + ' ' + iconClass}
                    placeholder={placeholder}
                    type={type === 'password' ? typeChange : type}
                    onChange={e => onChange && onChange(e.target.value)}
                    value={value}
                    // onFocus={() => setisFocus(true)}
                    // onBlur={e => { setisFocus(false); onBlur && onBlur(e) }}
                    min={min}
                    ref={register}
                    {...params}
                />
                :
                <select
                    className={(isWomenWebinar ? "f-input-webinar-item f-input-webinar-item--women select " :"f-input-webinar-item select ") + errorClass + ' ' + disabledClass + ' ' + iconClass}
                    onChange={e => onChange && onChange(e.target.value)}
                    defaultValue={props.defaultValue || ''}
                    ref={register}
                    {...params}
                >
                    <option disabled selected value="">{placeholder}</option>
                    {options && options.map((item, index) => {
                        return (
                            <option value={item.value} key={index}>{item.label}</option>
                        )
                    })}
                </select>
            }
            {type === 'password' ?
                typeChange === 'password' ?
                    <div className="f-icon-container">
                        <Icons.Visibility onClick={() => settypeChange('text')} />
                    </div>
                    :
                    <div className="f-icon-container">
                        <Icons.VisibilityOff onClick={() => settypeChange('password')} />
                    </div>
                :
                null
            }
            {/* <span className={"icon-container " + errorClass + ' ' + (isFocus ? 'is-focus' : '')}>
                {icon}
            </span> */}
            {error && <span className="error-text">{error}</span>}
        </div>
    )
}

export default InputWebinar
